import React from 'react'
import './style.css'
import MaterialIcons from 'material-icons-react'


export default class Corretor extends React.Component {

    state = {
        isOpen : false,
        corretor : this.props.corretor.toObject(),
        participacoes : this.props.participacoes,
        seePassword : false,
        canDiscard : false,
    }

    toggleOpen = () => this.setState({isOpen:!this.state.isOpen})

    s = (stateNew) => {
        this.setState({...stateNew, canDiscard:true});
        console.log('s = (stateNew)', this.state, stateNew)
    }

    handlers = {
        nome : (e) => this.s({corretor : {...this.state.corretor, nome : e.target.value}}),
        usuario : (e) => this.s({corretor : {...this.state.corretor, usuario : e.target.value}}),
        senha : (e) => this.s({corretor : {...this.state.corretor, senha : e.target.value}}),
        nivel : (e) => this.s({corretor : {...this.state.corretor, nivel : e.target.value}}),
        seePassword : () => this.s({seePassword:!this.state.seePassword}),
        telefones : (e, id) => {
            
            let f = [].concat(this.state.corretor.telefones || ['']);
            console.log('telefones e,id', e.target.value, id, f)
            if(f[id]===undefined) return
            f[id] = e.target.value
            
            this.s({corretor : {...this.state.corretor, telefones : f}})            
        }
    }

    descartar = () => {
        this.props.feedback('Nenhuma alteração foi realizada');
        if(this.state.canDiscard) this.setState({corretor : this.props.corretor.toObject()})
    }
    salvar = () => {
        this.props.feedback('Alterações salvas com sucesso!');
        this.props.salvar(this.state.corretor.id, this.state.corretor)
        this.setState({canDiscard : false})
    }
    deletar = () =>{
        this.props.feedback('Cadastro de corretor/usuário deletado com sucesso!');
        this.props.deletar(this.state.corretor.id);
    }

    addTelefone = () => this.s({corretor : {...this.state.corretor, telefones : this.state.corretor.telefones.concat([''])}})

    render(){

        let {corretor, participacoes} = this.state;
        console.log(this.props, this.state)
        corretor.telefones = corretor.telefones || ['']
        if(corretor.telefones.length===0) corretor.telefones = ['']

        let telefones = corretor.telefones.map((tel,k) => 
            <input type='text' key={'tel'+k} value={corretor.telefones[k]} onChange={(e) => this.handlers.telefones(e,k)}/>
        )
        telefones.push(<div key={'teladd'} className='telefone_add_action tooltip' onClick={this.addTelefone}><MaterialIcons icon='add'/><span className="tooltiptext">Adicionar telefone</span></div>)

        return(
            <div className='corretor'>
                <div className='minus'>
                    <span className='nome'>{corretor.nome || 'Nome não registrado(?)'}</span>
                    <span className='detalhes_pequenos'>
                        {(corretor.telefones[0].length>1)?<span className='telefone'>Telefone: {corretor.telefones[0]}</span>:<span className='telefone'>Sem telefone</span>}
                        <span className='lotes_counter'>Participação em {participacoes} lote(s)</span>
                    </span>
                    <div className='more_details_button' onClick={this.toggleOpen}>
                        <MaterialIcons icon={this.state.isOpen?'clear':'add'}/>
                    </div>
                </div>
                <hr className='details_edition_divider'/>
                <div className={`details_edition ${this.state.isOpen?'open':''}`}>
                    <div className='pessoais'>
                        <h3 className='details_edition_title'>
                            Informações pessoais
                        </h3>
                        <div className='form'>
                            <div className='nome'  requerido="true">
                                <label>Nome:</label>
                                <input type='text' value={this.state.corretor.nome} placeholder='Nome Completo' onChange={this.handlers.nome}/>
                            </div>
                            <div className='telefone'>
                                <label>Telefones:</label>
                                <div className='telefones_inputs'>
                                    {telefones}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='aplicativo'>
                        <h3 className='details_edition_title'>
                            Aplicativo
                        </h3>
                        <div className='form'>
                            <div className='usuario' requerido="true">
                                <label>Usuário:</label>
                                <input type='text'  value={this.state.corretor.usuario} placeholder='Nick de usuário'  onChange={this.handlers.usuario}/>
                            </div>
                            <div className='senha' requerido="true" senha='true'>
                                <label>Senha de acesso:</label>
                                <input type={this.state.seePassword?'text':'password'}  value={this.state.corretor.senha}  onChange={this.handlers.senha}/>
                                <label className='seepassword'>
                                    <input type='checkbox' checked={!this.state.seePassword} onChange={this.handlers.seePassword}/>
                                    <MaterialIcons icon='remove_red_eye'/>
                                </label>
                            </div>
                        </div>
                        <div className='nivel_acesso'>
                            <h3 className='nivel_acesso_title'>Nível de acesso</h3>
                            <label className='reservar'>
                                <input type='radio' value={1} checked={this.state.corretor.nivel==1} onChange={this.handlers.nivel}/>
                                Apenas reservar
                            </label>
                            <label className='reservar_vender'>
                                <input type='radio' value={2} checked={this.state.corretor.nivel==2} onChange={this.handlers.nivel}/>
                                Reservar/vender/disponibilizar
                            </label>
                            <label className='total'>
                                <input type='radio' value={3} checked={this.state.corretor.nivel==3} onChange={this.handlers.nivel}/>
                                Controle total em site
                            </label>
                        </div>
                    </div>
                    <div className='actions'>
                        <div className='salvar' onClick={this.salvar}>
                            Salvar
                        </div>
                        <div className='descartar' onClick={this.descartar}>
                            Descartar
                        </div>
                        <div className='descartar' onClick={()=> (window.confirm('Certeza de que deseja deletar?'))?this.deletar():null}>
                            Deletar
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/views/administrativo/corretores/corretor/component.js